export enum TrafficType {
    Unknown = 0,
    KnownBot = 1,
    UnknownBot = 2,
    Prerender = 3,
    User = 4,
    Internal = 5,
    NA = 6,
    DOS = 7,
}

export enum TrafficTypeCronos {
    NA,
    Known,
    Unknown,
    DOS,
    Prerender,
    Internal,
    UnknownDomain,
}
